import { render } from "./TheRegister.vue?vue&type=template&id=0f6fc608&scoped=true"
import script from "./TheRegister.vue?vue&type=script&lang=js"
export * from "./TheRegister.vue?vue&type=script&lang=js"

import "./TheRegister.vue?vue&type=style&index=0&id=0f6fc608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6fc608"]])

export default __exports__